.isEmphasized {
  background:
    linear-gradient(
      0deg,
      var(--dixa-color-neutral-000),
      var(--dixa-color-neutral-000)
    ),
    linear-gradient(
      92.6deg,
      rgba(193, 185, 248, 0.1) 0%,
      rgba(255, 255, 255, 0.1) 100%
    );
}

.content {
  max-height: 50vh;
  overflow-y: auto;
  width: 100%;
}
